<div class="h-full height-without-bar">
  <div class="mx-6 flex justify-center lg:top-0 lg:h-full lg:mx-0">
    <div class="w-full max-w-[485px] relative">
      <div class="h-full lg:px-8 2xl:px-12">
        <div class="relative lg:absolute cursor-pointer lg:top-6 mb-10 lg:mb-0 pt-6 lg:pt-0">
          <div (click)="backToHome()" class="flex items-center gap-x-2">
            <svg class="text-theme-muted" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.219749 5.47031L3.21975 2.47031C3.51272 2.17734 3.98733 2.17734 4.28029 2.47031C4.57326 2.76328 4.57326 3.23789 4.28029 3.53085L2.56174 5.25H11.25C11.6646 5.25 12 5.58539 12 6C12 6.41461 11.6646 6.75 11.25 6.75H2.56174L4.28158 8.46984C4.57455 8.76281 4.57455 9.23742 4.28158 9.53039C3.98885 9.82312 3.51424 9.82359 3.22104 9.53039L0.221038 6.53039C-0.0732199 6.23672 -0.0732199 5.76328 0.219749 5.47031Z"
                fill="currentColor" />
            </svg>
            <span class="text-xs text-theme-muted">
              {{ "search_page.back" | translate }}
            </span>
          </div>
        </div>

        <div class="flex flex-col items-center lg:justify-center mx-auto h-full">
          <div class="mb-10 lg:mb-12">
            <img alt="logo" [src]="ImageManager.getLogoNavbarByTerritoryCode()" width="198" height="47">
          </div>

          <div class="w-full">
            <h1 class="text-center text-2xl lg:text-3xl font-semibold">
              {{ 'forgot_password.title' | translate }}
            </h1>
            <p class="text-base text-center color-link mt-[0.5rem] md:mt-[1rem]">
              {{ 'forgot_password.subtitle' | translate }}
            </p>

            <form (ngSubmit)="onSubmit()" [formGroup]="forgotPasswordForm" class="mt-10 lg:mt-12">
              <div class="form-group flex items-center">
                <div class="absolute flex item-center px-3">
                  <svg fill="none" height="13" viewBox="0 0 17 13" width="17" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.888672 2.02246C0.888672 0.928711 1.76367 0.0224609 2.88867 0.0224609H14.8887C15.9824 0.0224609 16.8887 0.928711 16.8887 2.02246V10.0225C16.8887 11.1475 15.9824 12.0225 14.8887 12.0225H2.88867C1.76367 12.0225 0.888672 11.1475 0.888672 10.0225V2.02246ZM2.38867 2.02246V2.74121L7.76367 7.14746C8.41992 7.67871 9.32617 7.67871 9.98242 7.14746L15.3887 2.74121V2.02246C15.3887 1.77246 15.1387 1.52246 14.8887 1.52246H2.88867C2.60742 1.52246 2.38867 1.77246 2.38867 2.02246ZM2.38867 4.67871V10.0225C2.38867 10.3037 2.60742 10.5225 2.88867 10.5225H14.8887C15.1387 10.5225 15.3887 10.3037 15.3887 10.0225V4.67871L10.9512 8.30371C9.73242 9.30371 8.01367 9.30371 6.79492 8.30371L2.38867 4.67871Z"
                      fill="black" opacity="0.5" />
                  </svg>
                </div>
                <input class="custom-input bg-white border-solid-black text-base rounded-lg block w-full px-10 py-[12px] md:py-3.5"
                  formControlName="email" id="forgot-email" name="email"
                  placeholder="{{'forgot_password.email_placeholder' | translate}}" type="email">
              </div>
              @if (emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)) {
                <div
                  class="text-xs text-red-500 mt-2">
                  {{ 'forgot_password.email_error' | translate }}
                </div>
              }

              @if (!isSubmitting) {
                <button [disabled]="forgotPasswordForm.invalid"
                  class="custom-border-solid w-full btn-default rounded-lg text-base font-medium px-3.5 text-center mt-6 py-[12px] md:py-3.5"
                  type="submit">
                  {{ 'forgot_password.cta' | translate }}
                </button>
              }

              @if (isSubmitting) {
                <div class="flex justify-center items-center mt-6">
                  <div class="spinner-border custom-spinner" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              }
            </form>

            @if (showSuccessMessage) {
              <div class="alert alert-success mt-6 text-sm text-center" role="alert">
                {{ 'forgot_password.success_message' | translate }}
              </div>
            }
            @if (showErrorMessage) {
              <div class="alert alert-danger mt-6 text-sm text-center" role="alert">
                {{ errorMessage }}
              </div>
            }

            <div class="flex justify-center mt-10">
              <p class="text-center text-sm text-theme-muted">
                {{ 'forgot_password.back_to_login_label' | translate }}
                <a (click)="goToLogin()"
                class="font-medium text-primary-600 hover:underline cursor-pointer color-link">{{ 'forgot_password.back_to_login' | translate }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-full hidden lg:block">
      <div class="bg-cover bg-center h-full w-full" style="background-image: url(/assets/login-background.webp);"></div>
    </div>
  </div>
</div>
